"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IconLocationThematic = void 0;
var React = __importStar(require("react"));
var IconLocationThematic = function (props) { return (React.createElement("svg", __assign({ width: 24, height: 24, viewBox: "0 0 24 24" }, props),
    React.createElement("path", { fill: "#464650", fillRule: "evenodd", d: "M19.4997,9 L20.7617,9 L19.1607,5 L17.4997,5 L15.4997,5 L4.8387,5 L3.2377,9 L4.4997,9 L19.4997,9 Z M18.9997,20.5 L18.9997,10 L4.9997,10 L4.9997,20.5 C4.9997,20.775 5.2247,21 5.4997,21 L7.9997,21 L7.9997,16.5 C7.9997,16.224 8.2237,16 8.4997,16 L11.4997,16 C11.7757,16 11.9997,16.224 11.9997,16.5 L11.9997,21 L18.4997,21 C18.7747,21 18.9997,20.775 18.9997,20.5 Z M8.9997,21 L10.9997,21 L10.9997,17 L8.9997,17 L8.9997,21 Z M15.9997,4 L16.9997,4 L16.9997,3 L15.9997,3 L15.9997,4 Z M21.9637,9.314 C22.0247,9.469 22.0067,9.643 21.9137,9.78 C21.8207,9.918 21.6657,10 21.4997,10 L19.9997,10 L19.9997,20.5 C19.9997,21.327 19.3267,22 18.4997,22 L5.4997,22 C4.6727,22 3.9997,21.327 3.9997,20.5 L3.9997,10 L2.4997,10 C2.3337,10 2.1787,9.918 2.0857,9.78 C1.9927,9.643 1.9747,9.469 2.0357,9.314 L4.0357,4.314 C4.1107,4.124 4.2957,4 4.4997,4 L14.9997,4 L14.9997,2.5 C14.9997,2.224 15.2237,2 15.4997,2 L17.4997,2 C17.7757,2 17.9997,2.224 17.9997,2.5 L17.9997,4 L19.4997,4 C19.7037,4 19.8887,4.124 19.9637,4.314 L21.9637,9.314 Z M14,13 L16,13 L16,12 L14,12 L14,13 Z M13.5,14 C13.223,14 13,13.776 13,13.5 L13,11.5 C13,11.224 13.223,11 13.5,11 L16.5,11 C16.776,11 17,11.224 17,11.5 L17,13.5 C17,13.776 16.776,14 16.5,14 L13.5,14 Z" }))); };
exports.IconLocationThematic = IconLocationThematic;
exports.IconLocationThematic.defaultProps = {
    height: '30px',
    width: '30px'
};
exports.default = exports.IconLocationThematic;
